import React, { useContext } from 'react';
import * as SelectFunc from '../lib/selectFunc.js';

import { CustomizeContext } from '../contexts/customize';

const Select = (props) => {
  const { item, ind, name, option_type } = props;
  const { customizes, setCustomizes } = useContext(CustomizeContext);

  const getAttributes = (target, setData) => {
    const parent = target.currentTarget.closest('.selects-item');
    const id = parent.getAttribute('data-id');
    const value = parent.getAttribute('data-value');

    setData({
      id: id,
      value: value
    });
  };

  const createMarkup = (html) => {
    return { __html: html };
  };

  const selectItem = (e) => {
    const selectItemParent = e.currentTarget.closest('.mtm-item__wrapper');
    const selectItemName = selectItemParent.id.replace('mtm-', '');
    const activeItem = document.querySelectorAll(
      '#' + selectItemParent.id + ' .selects-item.active'
    );
    if (props.isSetAttributes) {
      getAttributes(e, props.setOptionData);
    }
    if (activeItem.length > 0) {
      activeItem[0].classList.remove('active');
      const dataOption = document.querySelectorAll(
        '#' + selectItemParent.id + ' [data-' + selectItemName + ']'
      );
      for (var i = 0; i < dataOption.length; i++) {
        if (dataOption[i].classList.contains('active')) {
          dataOption[i].classList.remove('active');
        }
        const clericItems = document.querySelectorAll(
          '#' + selectItemParent.id + ' .options-item__type__button'
        );
        for (let i = 0; i < clericItems.length; i++) {
          if (clericItems[i].classList.contains('checked')) {
            clericItems[i].classList.remove('checked');
          }
        }
      }
    }

    const openItem = document.querySelectorAll(
      '#' + selectItemParent.id + ' .selects-item.open'
    );
    openItem[0].classList.add('active');
    openItem[0].classList.remove('open');
    openItem[0].style.marginBottom = '0';

    customizes[name].id = openItem[0].dataset.id;
    customizes[name].label = openItem[0].dataset.label;
    customizes[name].value = openItem[0].dataset.value;
    customizes[name].img = openItem[0].dataset.img;
    setCustomizes({ ...customizes });

    const dataTimelineName = 'mtm-' + selectItemName;
    const dataTimeline = document.querySelectorAll(
      '[data-timeline="' + dataTimelineName + '"]'
    );
    dataTimeline[0].nextElementSibling.classList.add('active');

    const selectValue = openItem[0].dataset.value;
    const dataOption = document.querySelectorAll(
      '#' + selectItemParent.id + ' [data-' + selectItemName + ']'
    );
    for (let i = 0; i < dataOption.length; i++) {
      if (dataOption[i].dataset[selectItemName] == selectValue) {
        dataOption[i].classList.add('active');
      }
    }

    if (selectItemParent.nextElementSibling) {
      selectItemParent.nextElementSibling.classList.add('active');
    }

    if (
      selectItemParent.id == 'mtm-collars' &&
      openItem[0].dataset.optiontype != 0
    ) {
      const nextScroll = document.getElementById('mtm-collars__option');
      const nextScrollRect = nextScroll.getBoundingClientRect();
      const nextScrollTop = nextScrollRect.top;
      const py = window.pageYOffset + nextScrollTop;
      const header_h = document.getElementById('SiteHeader').clientHeight;
      const targetTop = py - header_h - 150;
      window.scrollTo({
        top: targetTop,
        behavior: 'smooth'
      });
    } else if (
      selectItemParent.id == 'mtm-cuffs' &&
      openItem[0].dataset.optiontype != 0
    ) {
      const nextScroll = document.getElementById('mtm-cuffs__option');
      const nextScrollRect = nextScroll.getBoundingClientRect();
      const nextScrollTop = nextScrollRect.top;
      const py = window.pageYOffset + nextScrollTop;
      const header_h = document.getElementById('SiteHeader').clientHeight;
      const targetTop = py - header_h - 150;
      window.scrollTo({
        top: targetTop,
        behavior: 'smooth'
      });
    } else if (
      selectItemParent.id == 'mtm-button'
    ) {
      document.getElementById('mtm-confirm').classList.add('active');
    } else {
      if (selectItemParent.nextElementSibling) {
        const nextScroll = document.getElementById(
          selectItemParent.nextElementSibling.id
        );
        const nextScrollRect = nextScroll.getBoundingClientRect();
        const nextScrollTop = nextScrollRect.top;
        const py = window.pageYOffset + nextScrollTop;
        const header_h = document.getElementById('SiteHeader').clientHeight;
        const targetTop = py - header_h;
        window.scrollTo({
          top: targetTop,
          behavior: 'smooth'
        });
      }
    }
  };

  return (
    <div
      className="selects-item"
      data-key={name}
      key={`${name}-${ind}`}
      data-id={item.id}
      data-label={item.label}
      data-value={item.value}
      data-img={item.image_url}
      data-optiontype={option_type}
    >
      <div className="selects-item__head" onClick={SelectFunc.openSelect}>
        <div className="selects-item__head__image">
          <img src={item.image_url} />
          <div className="selects-item__head__selected">
            <svg
              width="35"
              height="26"
              viewBox="0 0 35 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2 12.2L12.5283 23L33 2"
                stroke="white"
                strokeWidth="3"
              />
            </svg>
            <p>Selected</p>
          </div>
        </div>
        <h4>{item.label}</h4>
      </div>
      <div className="selects-item__detail">
        <div
          className="selects-item__detail_bg sp"
          onClick={SelectFunc.closeSelect}
        ></div>
        <div className="selects-item__detail__wrapper">
          <div
            className="selects-item__detail_closeBtn sp"
            onClick={SelectFunc.closeBtnSelect}
          ></div>
          <div
            className="selects-item__detail_contents"
            dangerouslySetInnerHTML={createMarkup(item.description)}
          />
          <div className="selects-item__detail_button">
            <button onClick={selectItem}>Select this {name}</button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Select;
